import { API_URL_FAQ } from "@constants/env";
import useApiCall from "@hooks/Shared/useApiCall";
import IFaq from "@interfaces/faq";

const useGetFaq = (uuid: string) =>
  useApiCall<IFaq>({
    url: API_URL_FAQ + uuid,
  });

export default useGetFaq;
